var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.hasRecommendations)?_c('b-row',[_c('b-col',[_vm._v(" From "),_c('b',[_vm._v(_vm._s(_vm.recommendations.min_year))]),_vm._v(" to "),_c('b',[_vm._v(_vm._s(_vm.recommendations.max_year))])])],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }